<template>
  <div class="step-header">
    <slot/>
  </div>
</template>

<script>
export default {
  name: "HeaderBase"
}
</script>

<style scoped lang="scss">
.step-header {
  height: 60px;
  width: 100%;
  z-index: 2;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.05);
  background-color: var(--configurator-primary-light-background-color);
  display: flex;
  align-items: center;

  .steps {
    position: relative;
    display: flex;
  }
}
</style>